/* 
Update the button text of the featured image upload button
when image is selected (On the contribution form)
*/

jQuery(function ($) {
    let fileUpload = $('.upload-featured input[type="file"]');
    
	if (fileUpload.length) {
		setupGravityForms($, fileUpload);
	}
});

function setupGravityForms($, fileUpload) {
	fileUpload.focus( function() {
		$('.upload-featured').addClass('focused');
	});

	$('.upload-featured input[type="file"]').focusout( function() {
		$('.upload-featured').removeClass('focused');
	});

	var input	 = $( '.upload-featured input[type="file"]' ),
	    label	 = $( '.upload-featured label' ),
		labelVal = label.html();

	input.on( 'change', function( e ) {
		var fileName = '';

		if( this.files && this.files.length > 1 )
			fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
		else if( e.target.value )
			fileName = e.target.value.split( '\\' ).pop();

		if( fileName )
			label.html( fileName );
		else
			label.html( labelVal );
	});

	input
	.on( 'focus', function(){ input.addClass( 'has-focus' ); })
	.on( 'blur', function(){ input.removeClass( 'has-focus' ); });
}